<template>
  <div class="data-panel veteran-panel">
    <div class="data-panel-header">
      <h2>{{title}}</h2>
    </div>
    <div class="data-panel-content" :style="{padding: '12px 0'}">
      <a-table :loading="loading" rowKey="account_id" :pagination="pagination" :columns="columns" :data-source="veteranList" bordered size="small" @change="handleTableChange" :scroll="{ x: '100%' }">
      </a-table>
    </div>
  </div>
</template>

<script>
const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 30,
}
const DEFAULT_SORT = {
  orderBy: 'lh_pay',
  orderType: 'desc'
}

export default {
  name: 'veteranPanel',
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: '历史玩家挖掘'
    }
  },
  data() {
    return {
      pagination: {
        ...DEFAULT_PAGINATION,
        showSizeChanger: true,
        showQuickJumper: true,
        size: "middle",
        showTotal: (total) => `共 ${total} 条`,
      },
      loading: false,
      veteranList: [],
      columns: [
        // { title: '账号', dataIndex: 'account_id' },
        { title: '角色id', dataIndex: 'role_id' },
        { title: '角色昵称', dataIndex: 'role_name', width: 120 },
        { title: '第一次登录', dataIndex: 'first_dt', sorter: true, width: 80 },
        { title: '最后一次登录', dataIndex: 'last_dt', sorter: true, width: 80 },
        { title: '累计活跃天数', dataIndex: 'active_days', sorter: true, width: 72, align: 'center' },
        { title: '雷火游戏累充', dataIndex: 'lh_pay', sorter: true, width: 80, align: 'center', defaultSortOrder: 'descend' },
        {
          title: '累计充值',
          children: [
            { title: 'L16', dataIndex: 'l16_pay', sorter: true, align: 'center' },
            { title: 'D10', dataIndex: 'd10_pay', sorter: true, align: 'center' },
            { title: 'D41', dataIndex: 'd41_pay', sorter: true, align: 'center' },
            { title: 'D90', dataIndex: 'd90_pay', sorter: true, align: 'center' },
            { title: 'L10', dataIndex: 'l10_pay', sorter: true, align: 'center' },
            { title: 'L12', dataIndex: 'l12_pay', sorter: true, align: 'center' },
            { title: 'L17', dataIndex: 'l17_pay', sorter: true, align: 'center' },
            { title: 'L20', dataIndex: 'l20_pay', sorter: true, align: 'center' },
            { title: 'L30', dataIndex: 'l30_pay', sorter: true, align: 'center' },
            { title: 'LH2', dataIndex: 'lh2_pay', sorter: true, align: 'center' },
            { title: 'LH3', dataIndex: 'lh3_pay', sorter: true, align: 'center' },
            { title: 'MN1', dataIndex: 'mn1_pay', sorter: true, align: 'center' },
            { title: 'D30', dataIndex: 'nsh_pay', sorter: true, align: 'center' },
            { title: 'L32', dataIndex: 'pm02_pay', sorter: true, align: 'center' },
            { title: 'L35', dataIndex: 'pm03_pay', sorter: true, align: 'center' },
            { title: 'D21', dataIndex: 'typc_pay', sorter: true, align: 'center' },
          ]
        }, 
      ]
    }
  },
  // computed: {
  //   dataSource() {
  //     return this.veteranList.map(v => ({

  //     }))
  //   }
  // },
  mounted() {
    this.getVeteranList(DEFAULT_PAGINATION, DEFAULT_SORT);
  },  
  methods: {
    getVeteranList(paginationInfo, params) {
      this.loading = true;
      this.$service.query_fixed_module(this.api, {
        current: paginationInfo.current,
        pageSize: paginationInfo.pageSize || pagination.pageSize,
        ...params,
      }).then(res => {
        this.loading = false;
        if (res.data) {
          this.veteranList = res.data.list || [];
          this.pagination = {
            ...this.pagination,
            ...(res.data.pagination || {}),
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleTableChange(rPagination, filters, sorter) {
      const sortParam = {};
      if (sorter.order) {
        sortParam.orderBy = sorter.field;
        sortParam.orderType = sorter.order === 'ascend' ? "asc" : sorter.order === 'descend' ? "desc" : "";
      }
      this.getVeteranList(rPagination, sortParam);
    }
  }
}
</script>

<style lang="less">
.veteran-panel {
  .ant-table-small>.ant-table-content>.ant-table-body {
    margin: 0;
  }
  .ant-table-thead > tr {
      background:#f2f2f2;
  }
}

</style>